import { LinearFilter, SRGBColorSpace, Texture, TextureLoader } from 'three/webgpu';
import { Anims, type AtlasManifestJson } from '@src/game/AnimDefs';

export interface Atlas {
  texture: Texture;
  manifest: AtlasManifestJson;
}

/**
 * Loads the packed sprite atlas and registers its clips with the animation
 * registry. Resolves to null when the atlas has not been generated yet so the
 * game can fall back to procedural shapes.
 */
export async function loadAtlas(basePath = '/assets/atlas'): Promise<Atlas | null> {
  let manifest: AtlasManifestJson;
  try {
    const res = await fetch(`${basePath}/sprites.json`, { cache: 'no-cache' });
    if (!res.ok) return null;
    manifest = (await res.json()) as AtlasManifestJson;
  } catch {
    return null;
  }

  const texture = await new Promise<Texture | null>((resolve) => {
    new TextureLoader().load(
      `${basePath}/sprites.png`,
      (t) => resolve(t),
      undefined,
      () => resolve(null),
    );
  });
  if (!texture) return null;

  texture.colorSpace = SRGBColorSpace;
  texture.magFilter = LinearFilter;
  texture.minFilter = LinearFilter;
  texture.generateMipmaps = false;
  texture.needsUpdate = true;
  Anims.load(manifest);
  return { texture, manifest };
}
